<template>
    <div class="custom-select" @blur="open = false">
        <div class="overlay" v-on:click="open=false" v-if="open">

        </div>
        <div class="selected" :class="{ open: open }" @click.prevent="open = !open">
            {{ selected.label }}
        </div>
        <div class="items" :class="{ selectHide: !open }">
            <div
                v-for="(option) of options"
                :key="option.id"
                :style="option.style"
                @click="itemClick(option)"
            >
                {{ option.label }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'custom-select',
    props: {
        options: {
            type: Array,
            required: true,
        },
        defaultId: {
            type: String,
            required: false,
            default: null,
        },
        preventSelect: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selected: this.defaultId
                ? this.options.find(o => o.id === this.defaultId)
                : this.options.length > 0
                    ? this.options[0]
                    : null,
            open: false,
        };
    },
    methods: {
        itemClick: function (option) {
            if (!this.preventSelect) {
                this.selected = option;
            }
            this.open = false;
            this.$emit('change', option.id);

        }
    },
};
</script>

<style scoped>

.custom-select {
    position: relative;
    width: 100%;
    text-align: center;
    outline: none;
    height: 32px;
    line-height: 32px;
}

.custom-select .selected {
    border-radius: 6px;
    cursor: pointer;
    user-select: none;
}

.custom-select .selected.open {
    border-radius: 6px 6px 0px 0px;
}

.custom-select .items {
    border-radius: 6px;
    background: white;
    overflow: hidden;
    width: 200px;
    margin-left: -100px;
    position: absolute;
    left: 50%;
    right: 0;
    z-index: 11;
    border: 1px solid #7f735c;
}

.custom-select .items div {
    cursor: pointer;
    user-select: none;
}

.custom-select .items div:hover {
    background: #7f735c;
    color: white;
}

.selectHide {
    display: none;
}

.overlay {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/templates/part/ui/custom-select.vue